export default __webpack_public_path__ + "static/media/client_trina.e8073b77.jpeg";